import { useAppMenuItemsStore } from '../stores/app-menu-items';
import { computed } from 'vue';

export function useAppMenuItems() {
    const appMenuStore = useAppMenuItemsStore();

    return computed({
        get: () => appMenuStore.items,
        set: (newValue) => (appMenuStore.items = newValue),
    });
}

export function useAppMenu() {
    const items = useAppMenuItems();
    const appMenuStore = useAppMenuItemsStore();

    const activeItem = computed({
        get: () => appMenuStore.activeItem,
        set: (newValue) => (appMenuStore.activeItem = newValue),
    });

    return {
        items,
        activeItem,
    };
}
